import React, { useState } from 'react'
const CBSelect = ({children, onChange, labels=[],values=[], selected=-1,style={}}) => {
    const [selIndex,setSelIndex] = useState(selected != -1 ? values.indexOf(selected) : -1)
    return <select style={style} className="w-max text-Sarabun bg-neutral_1 shadow-inner pl-2 pr-2 pt-2 pb-2" 
    onChange={e => onChange(e.target.value)} >
    {values.map ((v, i) => {
      return <option key={v} className=" text-Sarabun pl-1 pr-1 pt-3 pb-3" value={v} selected={selIndex === i}>{labels[i]}</option>
    })}
  </select>
}

  export { CBSelect }
